module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./SpaceMgmtView.jsx"));
	}, "SpaceMgmt");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpaceMgmt!./src/pages/bundle-appResource-mgmt/SpaceMgmt/SpaceMgmtView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=SpaceMgmt!./src/pages/bundle-appResource-mgmt/SpaceMgmt/SpaceMgmtView.jsx
// module chunks = 43